import { BasePostInputModel } from "../../../../../models/http/InputModel/BasePostInputModel"

import { ApiUserData } from "src/models/user/ApiUserData"
import { GiftItem } from "src/models/gift/GiftItem"

export type UserToUserIdGiftPostParams = {
  user: ApiUserData
  gift_item: GiftItem
  send_message_id: string
  send_free_message: string
  commission_id?: number
}

export class UserToUserIdGiftInputModel extends BasePostInputModel {
  constructor(private params: UserToUserIdGiftPostParams) {
    super()
  }

  get pathParams() {
    return {
      toUserId: this.params.user.id.toString(),
    }
  }
  get body() {
    return {
      gift_items: [
        {
          gift_item_id: this.params.gift_item.type.id,
          amount: this.params.gift_item.amount,
        },
      ],
      send_message_id: this.params.send_message_id,
      send_free_message: !this.params.send_free_message
        ? null
        : this.params.send_free_message,
      commission_id: !this.params.commission_id
        ? null
        : this.params.commission_id,
    }
  }
}
